export default __webpack_public_path__ + "static/fluo-logo-white-b8c96ba6736d5d8421e390f31b29decc.svg";